import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";

import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
    inject,
} from "@angular/core";

import { TilbyItemElementComponent } from "@tilby/tilby-ui-lib/components/tilby-item-element";
import { ConfigurationManagerService } from "src/app/core";
import { Items } from "tilby-models";
import { CashregisterStateService } from "../../services";
import { keyBy } from "src/app/shared/utils";

@Component({
    selector: "app-showcase-list",
    templateUrl: "./showcase-list.component.html",
    styleUrls: ["./showcase-list.component.scss"],
    standalone: true,
    imports: [
        CommonModule,
        ScrollingModule,
        TilbyItemElementComponent
    ]
})
export class ShowcaseListComponent implements OnChanges {
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    protected readonly cashregisterStateService = inject(CashregisterStateService);

    @Input({required:true}) itemsSet!: Items[];
    @Input() priceList = 1;
    @Input() getStockStatus: Function = () => {};
    @Input() showThumbnail = true;
    @Input() showUnavailableStock = true;
    @Input() truncatePriceWithDots = true;
    @Input() priceWithCurrency = true;
    @Input() customClass = '';
    @Input() fontNameSize = 12;
    @Input() fontPriceSize = 12;
    @Input() showItemIcon = false;
    @Output() onItemTap: EventEmitter<Items> = new EventEmitter<Items>();
    @Output() onItemPress: EventEmitter<Items> = new EventEmitter<Items>();

    protected categoriesById = keyBy(this.cashregisterStateService.categories, (c) => c.id);
    protected screenHeight = screen.height;
    protected showPrices = this.configurationManagerService.isUserPermitted('show_prices_ui');
    protected priceIdentifier: keyof Items = "price1";

    itemTap(item: Items): void {
        this.onItemTap.emit(item);
    }

    itemPress(item: Items): void {
        this.onItemPress.emit(item);
    }

    trackByFunction(index: number, item: Items): number {
        return item.id!;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.priceList) {
            this.priceIdentifier = `price${changes.priceList.currentValue}` as keyof Items;
        }

        if(changes.fontNameSize) {
            this.fontNameSize = changes.fontNameSize.currentValue;
        }

        if(changes.fontPriceSize) {
            this.fontPriceSize = changes.fontPriceSize.currentValue;
        }
    }
}
